import { graphql } from "@/gql";

export const promotionCountsQuery = graphql(`
  query PromotionCounts {
    promotionCounts {
      active
      inactive
      total
    }
  }
`);
